// Backends before the server-owned slugs (backend/turnus_ai/services/kb_slug.py) require a `slug`
// matching ^[a-z0-9-]+$ on every category/tag create. Frontend and backend deploy and roll back
// independently, so requests keep sending one; newer backends ignore it and derive their own.
// Remove once no deployed or rollback-target backend requires the field.

const TRANSLITERATIONS: Record<string, string> = {
  ä: "ae",
  ö: "oe",
  ü: "ue",
  ß: "ss",
  æ: "ae",
  œ: "oe",
  ø: "oe",
  ł: "l",
  đ: "d",
  ð: "d",
  þ: "th",
}

const SLUG_MAX_LENGTH = 100

export const legacySlug = (name: string): string => {
  const slug = name
    .trim()
    .toLocaleLowerCase()
    .normalize("NFC")
    .replace(/[äöüßæœøłđðþ]/g, (char) => TRANSLITERATIONS[char])
    .normalize("NFKD")
    .replace(/\p{M}/gu, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, SLUG_MAX_LENGTH)
    .replace(/-+$/, "")
  // Names without Latin letters still need a valid value; it only has to pass the old pattern.
  return slug || "n"
}
